import Axios from "axios";
import { getParameterByName } from "../../getParameters";
import * as jQuery from "jquery";
export interface TournamentDto {
    page: number;
    limit: number;
  }



export class tournamentAPICall {
  private tournamentURL: string;
  private tournamentScoreURL: string;
  private tournamentInfoURL: string;
  private tournamentRegisterURL: string;
  private endpoint: string;
  private timeOut:number=10000;
  private token:string;
  private tournamentId:string= getParameterByName("tournamentId");;
  constructor(endPoint: string,token:string) {
    this.endpoint = endPoint;
    this.token=token;
    //all the urls

    this.tournamentURL = this.endpoint + "/tournament/ranking";
    this.tournamentScoreURL = this.endpoint + "/tournament/participation";
    this.tournamentInfoURL = this.endpoint + "/tournament/information";
    this.tournamentRegisterURL = this.endpoint + "/tournament/register";

}

  public GetTournamentScore = (
    requestSuccess: Function,
    requestError: Function
  )=> {
    let self = this;
    Axios({
      method: "get",
      url:  this.tournamentScoreURL,
      data: {},
      timeout: this.timeOut,
      headers: { "X-Token": this.token },
    })
      .then(function(response) {
        requestSuccess(response.data);
      })
      .catch(function(error) {
        self.errorHandle(error, requestError);
      });

  };
  public GetTournamentRanking = (
    dataParam: TournamentDto,
    requestSuccess: Function,
    requestError: Function
  ) => {
    let self = this;
    Axios({
      method: "get",
      url: this.tournamentURL+ "?" + jQuery.param(dataParam),
      data: {},
      timeout: this.timeOut,
      headers: { "X-Token": this.token },
    })
      .then(function(response) {
        requestSuccess(response.data);
      })
      .catch(function(error) {
        self.errorHandle(error, requestError);
      });
  };
  public GetTournamentRegister= (
    
    requestSuccess: Function,
    requestError: Function
  ) => {
    let self = this;
    let bodydata= {
        tournamentId:this.tournamentId
    }
    // console.log("REGISTER/REBUY PRESS",this.tournamentId)
    Axios({
      method: "post",
      url: this.tournamentRegisterURL,//+ "?" + jQuery.param(dataParam),
      data: bodydata,
      timeout: this.timeOut,
      headers: { "X-Token": this.token },
    })
      .then(function(response) {
        // console.log(response)
        // console.log(response.data);
        // console.log(response.data.tournamentID);
        // this.tournamentId= response.data.tournamentId;
        requestSuccess(response.data);
      })
      .catch(function(error) {
        self.errorHandle(error, requestError);
      });
  };
  public setNewTournamnetID=(newID:string):void=>
  {
    this.tournamentId= newID;
  }
  public GetTournamentInfos= (
    
    requestSuccess: Function,
    requestError: Function
  ) => {
    // console.log("REUEST INFOS")    
    let self = this;
    let dataParam= {
        tournamentId:this.tournamentId
    }
    // console.log("REGISTER/REBUY PRESS",this.tournamentId)
    Axios({
      method: "get",
      url: this.tournamentInfoURL+ "?" + jQuery.param(dataParam),
      data: {},
      timeout: this.timeOut,
      headers: { "X-Token": this.token },
    })
      .then(function(response) {

        requestSuccess(response.data);
      })
      .catch(function(error) {

        self.errorHandle(error, requestError);
      });
  };
  private errorHandle = (error: any, requestError: Function) => {
    console.log("ERROR: ", error);

    let errorType;
    if (error.response == undefined) {
      errorType = "UNKNOWN";
      if (error.code == "ECONNABORTED") {
        errorType = "TIMEOUTERROR";
      }
      if ((error = "Error: Network Error")) {
        errorType = "networkErrorBody";
      }
    } else {
      errorType = error.response.data.errorType;
      if (errorType == undefined) {
        errorType = "UNKNOWN";
      }
    }

    requestError(errorType);
  };
  

  public setToken = (newID: string): void => {
    this.token = newID;
    // console.log("game token is replaced with " ,this.token)
  };

}
